var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning_x5F_sign",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.148,41.506C44.605,42.441,43.635,43,42.554,43H5.446c-1.082,0-2.052-0.559-2.595-1.495 c-0.543-0.936-0.546-2.055-0.009-2.993L21.396,6.043C21.936,5.096,22.91,4.531,24,4.531c1.09,0,2.063,0.565,2.604,1.511 l18.554,32.469C45.695,39.451,45.691,40.57,45.148,41.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E20613"
    },
    d: "M24,9.547L40.83,39H7.169L24,9.547 M24,5.531c-0.676,0-1.353,0.336-1.736,1.008L3.71,39.008 C2.948,40.341,3.911,42,5.446,42h37.107c1.536,0,2.498-1.659,1.736-2.992L25.736,6.539C25.353,5.867,24.676,5.531,24,5.531L24,5.531 z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,36h-4v-4h4V36z M26,18h-4l1,12h2L26,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningSign);
export default __webpack_public_path__ + "static/media/icon-warning_sign.29ff29d8e6c21bd448df65a731ace949.svg";
export { ForwardRef as ReactComponent };